import { Text, Thumbnail } from '@shopify/polaris'

import { generateDefaultAvatar } from '../utils/avatarUtils'

interface AvatarProps {
  name: string
  picture?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export default function Avatar({ name, picture, size = 'md' }: AvatarProps) {
  const sizeMap = {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
  }

  const thumbnailSizeMap: Record<
    NonNullable<AvatarProps['size']>,
    'small' | 'medium' | 'large'
  > = {
    xs: 'small',
    sm: 'small',
    md: 'medium',
    lg: 'large',
    xl: 'large',
  }

  const pixelSize = sizeMap[size]

  if (picture) {
    return (
      <Thumbnail size={thumbnailSizeMap[size]} source={picture} alt={name} />
    )
  }

  const defaultAvatar = generateDefaultAvatar(name, pixelSize)

  return (
    <div
      style={{
        backgroundColor: defaultAvatar.backgroundColor,
        borderRadius: '50%',
        width: `${pixelSize}px`,
        height: `${pixelSize}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Text
        as="span"
        variant={size === 'xs' || size === 'sm' ? 'bodySm' : 'bodyMd'}
        fontWeight="semibold"
        tone="text-inverse"
      >
        {defaultAvatar.initials}
      </Text>
    </div>
  )
}
